import script from "./activity.vue?vue&type=script&setup=true&lang=js"
export * from "./activity.vue?vue&type=script&setup=true&lang=js"

import "./activity.vue?vue&type=style&index=0&id=b02d28b8&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b02d28b8"]])

export default __exports__